"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPReviewComponent = void 0;
const core_1 = require("@angular/core");
const expresspay_services_1 = require("../../../shared/services/expresspay.services");
const helper_service_1 = require("../../../../mma/shared/services/helper.service");
const shared_1 = require("../../../../mma/shared");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
class CSEPReviewComponent {
    constructor(expressPayService, helperService, modalService, genericContentServiceV2) {
        this.expressPayService = expressPayService;
        this.helperService = helperService;
        this.modalService = modalService;
        this.genericContentServiceV2 = genericContentServiceV2;
        this.edit = new core_1.EventEmitter();
        this.next = new core_1.EventEmitter();
        this.paymentType = new core_1.EventEmitter();
        this.confirmationNumber = new core_1.EventEmitter();
        this.genericError904 = new core_1.EventEmitter();
        this.classes = 'col-12';
        this.disablePaymentButton = false;
        this.cardMonth = [
            '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
        ];
        this.cardYear = [
            '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027'
        ];
        this.scrollTop();
    }
    ngOnInit() {
        this.payAmount = true;
        this.paymentMethod = this.paymentMethodData.setPaymentMethod;
        this.getBillingAddress();
        this.getSessionId();
        this.getGenericContent();
    }
    editPaymentInfo() {
        this.paymentDetails = null;
        this.funds = null;
        this.giftCardData = null;
        this.bankAccountDetails = null;
        this.edit.emit(true);
    }
    submit(reviewPaymentDetails) {
        this.error = null;
        this.scrollTop();
        this.disablePaymentButton = true;
        this.paymentMethod = this.paymentMethodData.setPaymentMethod;
        if (this.paymentMethodData.setPaymentMethod === 'GIFT_CARD') {
            const content = {
                'amountToPay': this.funds.amountToPay,
                'payInFull': this.funds.payInFull,
                'payPastDueBalance': this.funds.payPastDueBalance,
                'giftCard': {
                    'gcNumber': this.giftCardData.giftCardNumber,
                    'gcPin': this.giftCardData.giftCardPin,
                    'gcBalance': this.giftCardData.giftCardBalance,
                }
            };
            this.loader = true;
            this.expressPayService.submitPaymentByGiftCard(content).subscribe((data) => {
                this.loader = false;
                this.paymentType.emit(this.paymentMethod);
                this.confirmationNumber.emit(data.authCode);
                this.next.emit(true);
            }, (err) => {
                this.handleSubmitError(err);
            });
        }
        else {
            const ccContents = this.payByCreditCard(this.ccContentData, reviewPaymentDetails);
            this.loader = true;
            this.expressPayService.submitFinalPayment(ccContents).subscribe((res) => {
                this.loader = false;
                this.confirmationNumber.emit(res.creditCard.authCode);
                this.paymentType.emit(this.paymentMethod);
                this.genericError904.emit(res.errorIdOnPaymentSuccess);
                this.next.emit(true);
            }, (err) => {
                this.handleSubmitError(err);
            });
        }
    }
    handleSubmitError(err) {
        this.loader = false;
        this.error = err;
        this.disablePaymentButton = true;
        this.scrollTop();
    }
    payByCreditCard(ccContent, reviewPaymentDetails) {
        // let content = {};
        const content = {
            amountToPay: ccContent.amountToPay,
            convenienceFeeAmount: ccContent.convenienceFeeAmount,
            bankAccount: ccContent.bankAccount,
            termsAndConditions: reviewPaymentDetails.termscondition,
            giftCard: ccContent.giftCard,
            mobileNumber: ccContent.mobileNumber,
            payInFull: ccContent.payInFull,
            payPastDueBalance: ccContent.payPastDueBalance,
            prepaid: ccContent.prepaid,
            savePaymentInfo: ccContent.savePaymentInfo,
            subscriptionId: ccContent.subscriptionId,
            creditCard: {
                amountToPay: ccContent.creditCard.amountToPay,
                authCode: ccContent.creditCard.authCode,
                ccAddrSameAsBillingAddr: ccContent.creditCard.ccAddrSameAsBillingAddr,
                ccNumber: ccContent.creditCard.ccNumber,
                ccRepositoryId: ccContent.creditCard.ccRepositoryId,
                ccType: ccContent.creditCard.ccType,
                cvv: ccContent.creditCard.cvv,
                expMonth: ccContent.creditCard.expMonth,
                expYear: ccContent.creditCard.expYear,
                kHashToken: ccContent.creditCard.kHashToken,
                newCreditCard: ccContent.creditCard.newCreditCard,
                savedCcIndex: ccContent.creditCard.savedCcIndex,
                ccAddress: {
                    addressLine1: ccContent.creditCard.ccAddress.addressLine1,
                    addressLine2: ccContent.creditCard.ccAddress.addressLine2,
                    addressSelected: ccContent.creditCard.ccAddress.addressSelected,
                    city: ccContent.creditCard.ccAddress.city,
                    firstName: ccContent.creditCard.ccAddress.firstName,
                    lastName: ccContent.creditCard.ccAddress.lastName,
                    state: ccContent.creditCard.ccAddress.state,
                    zipCode: ccContent.creditCard.ccAddress.zipCode
                }
            }
        };
        return content;
    }
    getBillingAddress() {
        this.expressPayService.getPersonalInformation().subscribe((res) => {
            this.personalInfo = res;
        }, (err) => {
            this.error = err;
        });
    }
    getSessionId() {
        this.expressPayService.getSessionId().subscribe((res) => {
            this.riskSessionIdUrl = '/global/logo.jsp?sessionId=' + res.riskSessionId;
        }, (err) => {
            this.error = err;
        });
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    scrollTop() {
        window.scrollTo(0, 200);
    }
    open(content) {
        this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    goToMyExpressPay() {
        this.helperService.onNavigate('/my_account/personal/express-pay/');
    }
    getGenericContent() {
        const genericContentIds = [
            '/generic/agreement/advancePymtDetails',
            '/generic/agreement/PrepaidDraftEFTTerms',
            'genericConvenienceFeeNote'
        ];
        this.genericContentServiceV2.getBulkGenericContent(genericContentIds).subscribe((bulkGenericContent) => {
            for (const genericContentItem of bulkGenericContent) {
                if (genericContentItem.id === '/generic/agreement/advancePymtDetails') {
                    this.paymentDetailsPrepaid = genericContentItem;
                }
                if (genericContentItem.id === '/generic/agreement/PrepaidDraftEFTTerms') {
                    this.termsAndConditionInfo = genericContentItem;
                }
                if (genericContentItem.id === 'genericConvenienceFeeNote') {
                    this.convenienceFeeNote = genericContentItem.content;
                }
            }
        }, () => {
            this.paymentDetailsPrepaid = '';
            this.termsAndConditionInfo = '';
            this.convenienceFeeNote = '';
        });
    }
}
exports.CSEPReviewComponent = CSEPReviewComponent;
//# sourceMappingURL=review.component.js.map